import { Box, Grid, Paper, Typography } from "@mui/material";
import { formatCount } from "./summaryConstants";

const Card = ({ label, value, color, subtitle }) => (
  <Paper elevation={1} sx={{ p: 2, height: "100%", borderRadius: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
    >
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 700, color: color || "text.primary", mt: 0.5 }}>
      {value}
    </Typography>
    {subtitle != null && (
      <Typography variant="caption" color="text.secondary">
        {subtitle}
      </Typography>
    )}
  </Paper>
);

const percent = (part, whole) =>
  Number(whole || 0) ? `${Math.round((Number(part || 0) / Number(whole)) * 100)}% of all` : null;

const SummaryCards = ({ totals }) => {
  const t = totals || {};
  const cards = [
    {
      label: "Universities / Colleges",
      value: formatCount(t.universityCount),
      subtitle: `${formatCount(t.universitiesWithAdmissions)} with admissions`,
    },
    {
      label: "Total Admissions",
      value: formatCount(t.totalAdmissions),
      subtitle: t.unassignedAdmissions
        ? `${formatCount(t.unassignedAdmissions)} not linked to a college`
        : "All linked to a college",
    },
    {
      label: "Completed",
      value: formatCount(t.completed),
      color: "success.main",
      subtitle: percent(t.completed, t.totalAdmissions),
    },
    {
      label: "In Progress",
      value: formatCount(t.inProgress),
      color: "warning.main",
      subtitle: percent(t.inProgress, t.totalAdmissions),
    },
    {
      label: "Withdrawn",
      value: formatCount(t.withdrawn),
      color: "error.main",
      subtitle: percent(t.withdrawn, t.totalAdmissions),
    },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md={2.4} key={card.label}>
            <Card {...card} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SummaryCards;
